import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "betslip-header header-bar-surface" }
const _hoisted_2 = { class: "bet-count" }
const _hoisted_3 = {
  key: 0,
  class: "betslip-load-booking"
}
const _hoisted_4 = { class: "booking-input-container" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "booking-message success"
}
const _hoisted_8 = {
  key: 1,
  class: "booking-message error"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "booked-bet-success-inline"
}
const _hoisted_11 = { class: "booked-success-title" }
const _hoisted_12 = { class: "booking-info" }
const _hoisted_13 = { class: "booking-row" }
const _hoisted_14 = { class: "code-value" }
const _hoisted_15 = { class: "booking-row" }
const _hoisted_16 = { class: "booking-row" }
const _hoisted_17 = {
  key: 0,
  class: "barcode-box"
}
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "barcode-hint" }
const _hoisted_20 = { class: "booking-actions" }
const _hoisted_21 = {
  key: 1,
  class: "success-message"
}
const _hoisted_22 = { class: "success-content" }
const _hoisted_23 = { class: "success-text" }
const _hoisted_24 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_25 = {
  key: 3,
  class: "view-last-bet"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 3,
  class: "betslip-content"
}
const _hoisted_28 = { class: "bet-header" }
const _hoisted_29 = { class: "bet-title" }
const _hoisted_30 = { class: "game-name" }
const _hoisted_31 = { class: "game-date" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "bet-numbers" }
const _hoisted_34 = { class: "numbers-label" }
const _hoisted_35 = { class: "market-info" }
const _hoisted_36 = {
  key: 0,
  class: "market-desc"
}
const _hoisted_37 = { class: "bet-label" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "numbers-label" }
const _hoisted_40 = { class: "number-circles" }
const _hoisted_41 = {
  key: 0,
  class: "plus-sign"
}
const _hoisted_42 = { class: "bet-details" }
const _hoisted_43 = { class: "bet-controls" }
const _hoisted_44 = { class: "stake-draw-grid" }
const _hoisted_45 = { class: "draw-section" }
const _hoisted_46 = { class: "field-label" }
const _hoisted_47 = { class: "selected-draws-display" }
const _hoisted_48 = {
  key: 0,
  class: "draws-list"
}
const _hoisted_49 = {
  key: 1,
  class: "no-draws-selected"
}
const _hoisted_50 = { class: "stake-section" }
const _hoisted_51 = { class: "field-label" }
const _hoisted_52 = { class: "stake-input-container" }
const _hoisted_53 = { class: "currency-symbol" }
const _hoisted_54 = ["value", "min", "max", "step", "placeholder", "onInput", "onBlur", "onFocus"]
const _hoisted_55 = { class: "bet-row" }
const _hoisted_56 = { class: "bet-row" }
const _hoisted_57 = { class: "bet-row" }
const _hoisted_58 = { class: "win-amount" }
const _hoisted_59 = { class: "betslip-footer" }
const _hoisted_60 = { class: "clear-button-wrapper" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "total-bet" }
const _hoisted_63 = { class: "amount" }
const _hoisted_64 = { class: "total-bet" }
const _hoisted_65 = { class: "amount win-amount" }
const _hoisted_66 = {
  key: 0,
  class: "expired-bet-options"
}
const _hoisted_67 = { class: "expired-message" }
const _hoisted_68 = { class: "warning-text" }
const _hoisted_69 = { class: "expired-actions" }
const _hoisted_70 = {
  key: 1,
  class: "inline-error-message"
}
const _hoisted_71 = { class: "error-text" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 0,
  class: "payout-max-warning"
}

import {
  computed,
  watch,
  ref,
  nextTick,
  onMounted,
  onUnmounted,
  unref,
} from "vue";
import { storeToRefs } from "pinia";
import { useBetslipStore } from "../stores/betslip";
import type { BetslipItem } from "../stores/betslip";
import ToastComponent from "./ToastComponent.vue";
import { useToast } from "../composables/useToast";
import { useGameStore } from "../stores/game";
import { useTransactionsStore } from "../stores/transactions";
import { useAuthStore } from "../stores/auth";
import { useRouter, useRoute } from "vue-router";
import { formatCurrency, formatOdds } from '../utils/currency';
import { useBetSettings } from "../composables/useBetSettings";
import {
  calcPotentialWin,
  displayPotentialWin,
  normalizeStakeValue,
  sumPotentialWins,
  toNumber,
} from "../utils/betLimits";
import { iframeCommunication } from "../utils/iframeCommunication";
import BaseModal from "./BaseModal.vue";
import TransactionDetails from "./wagers/TransactionDetails.vue";
import { useI18n } from "vue-i18n";


const __default__ = {
  name: "BetSlip",
};


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close", "selectDraws", "drawsChanged", "clearedAfterSubmission"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

const betslipContainer = ref<HTMLElement | null>(null);

const gameStore = useGameStore();
const transactionsStore = useTransactionsStore();
const betslipStore = useBetslipStore();
const authStore = useAuthStore();
const { isAuthenticated } = storeToRefs(authStore);
const { removeBet, clearBetslip: storeClearBetslip, updateLastStake } = betslipStore;
const betslip = computed(() => betslipStore.betslip);
const { toast, showToast } = useToast();
const isProcessingBet = ref(false);
const showSuccess = ref(false);
const isUpdatingFromProps = ref(false);
const isClearingBetslip = ref(false);
const localStakeValues = ref<{ [key: number]: string }>({});
const showExpiredBetOptions = ref(false);
const expiredBets = ref<Array<{ betIndex: number; drawIndex: number; draw: { draw_date: string; cutoff: string; event_id: number } }>>([]);
const bookingCodeInput = ref('');
const isLoadingBooking = ref(false);
const bookingMessage = ref('');
const bookingErrorMessage = ref('');
const currentBookingCode = ref<string | null>(null);
const isProcessingBookBet = ref(false);
const bookBetSuccessData = ref<{
  booking_code: string;
  barcode?: string;
  expires_at?: string;
  total_bet_amount?: number;
  bets?: BetslipItem[];
} | null>(null);

const showBookABetModule = computed(() => {
  const modules = gameStore.getBetSettings?.enabled_modules;
  if (!Array.isArray(modules)) return false;
  return modules.includes('book_a_bet');
});

// Wrapper function for clearing betslip
const clearBetslip = (resetSuccess = true) => {
  isClearingBetslip.value = true;
  if (resetSuccess) {
    showSuccess.value = false; // Reset success message when manually clearing
  }
  storeClearBetslip();
  // Reset flag after a short delay
  setTimeout(() => {
    isClearingBetslip.value = false;
  }, 100);
};
const cleanupTimer = ref<number | null>(null);
const inlineError = ref<string | null>(null);
const isMobile = ref(false);
const openDrawDropdownIndex = ref<number | null>(null);
const clickOutsideHandler = ref<((event: MouseEvent) => void) | null>(null);
const isLastBetModalOpen = ref(false);
const isLoadingLastBet = ref(false);

const {
  betMin,
  betMax,
  payoutMax,
  payoutMaxPerBetslip,
  betLimit,
  betDefault,
  currencySymbol,
  allowDecimals,
} = useBetSettings();

const getBetLineMultipliers = (bet: BetslipItem) => {
  const drawCount = Array.isArray(bet.draws) ? bet.draws.length : 1;
  const numBets = typeof bet.numBets === "number" && bet.numBets > 0 ? bet.numBets : 1;
  return { drawCount, numBets };
};

const getStakeNormalizeOptions = () => ({
  betMin: unref(betMin),
  betMax: unref(betMax),
  payoutMax: unref(payoutMaxPerBetslip) ? 0 : unref(payoutMax),
  allowDecimals: unref(allowDecimals),
});

const getCappedWinForBet = (bet: BetslipItem): number => {
  const { drawCount, numBets } = getBetLineMultipliers(bet);
  const stake = bet.stake ?? 0;
  const odds = toNumber(bet.odds);
  if (unref(payoutMaxPerBetslip)) {
    return calcPotentialWin(stake, odds, drawCount, numBets);
  }
  return displayPotentialWin(stake, odds, unref(payoutMax), drawCount, numBets);
};

const betPotentialInputs = computed(() =>
  bets.value.map((bet) => {
    const { drawCount, numBets } = getBetLineMultipliers(bet);
    return {
      stake: bet.stake ?? 0,
      odds: toNumber(bet.odds),
      drawCount,
      numBets,
    };
  })
);

const totalRawPotentialWin = computed(() => sumPotentialWins(betPotentialInputs.value));

const exceedsBetslipPayoutMax = computed(
  () =>
    unref(payoutMaxPerBetslip) &&
    unref(payoutMax) > 0 &&
    totalRawPotentialWin.value > unref(payoutMax)
);

const betNowPayoutMaxMessage = computed(() => {
  if (!exceedsBetslipPayoutMax.value) return "";
  return t("betslip.maxPossibleWinExceeds", {
    amount: formatCurrency(unref(payoutMax), unref(displayCurrency)),
  });
});

const bets = computed(() => {
  return betslip.value || [];
});

// Wrapper function to handle index for removeBet
const removeBetAtIndex = (displayIndex: number) => {
  removeBet(displayIndex);
};

// Close betslip function for mobile
const closeBetslip = () => {
  emit('close');
};

const isEmpty = computed(() => {
  if (!bets.value || bets.value.length === 0) return true;
  return bets.value.some(
    (bet) =>
      !Array.isArray(bet.draws) ||
      bet.draws.length === 0 ||
      !bet.stake ||
      bet.stake <= 0
  );
});

const totalStake = computed(() => {
  if (!bets.value) return 0;
  return bets.value.reduce((total, bet) => {
    const drawCount = Array.isArray(bet.draws) ? bet.draws.length : 1;
    const numBets =
      typeof bet.numBets === "number" && bet.numBets > 0 ? bet.numBets : 1;
    return total + (bet.stake || 0) * numBets * drawCount;
  }, 0);
});

const displayCurrency = computed((): string => {
  if (bets.value && bets.value.length > 0) {
    const symbol = bets.value[0].currency_symbol;
    if (symbol) return symbol;
  }
  return unref(currencySymbol) || '';
});

const totalReturns = computed(() => {
  if (!bets.value) return 0;
  if (unref(payoutMaxPerBetslip)) {
    return totalRawPotentialWin.value;
  }
  return bets.value.reduce((total, bet) => total + getCappedWinForBet(bet), 0);
});

const isMobileViewport = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(max-width: 768px)').matches;

// Function to scroll betslip to bottom (desktop: show newly added line)
const scrollToBottom = () => {
  nextTick(() => {
    if (betslipContainer.value) {
      // Find the betslip-content element within the betslip container
      const betslipContent = betslipContainer.value.querySelector('.betslip-content') as HTMLElement;
      if (betslipContent) {
        betslipContent.scrollTo({
          top: betslipContent.scrollHeight,
          behavior: 'smooth'
        });
      } else {
        // Fallback to scrolling the main container
        betslipContainer.value.scrollTo({
          top: betslipContainer.value.scrollHeight,
          behavior: 'smooth'
        });
      }
    }
  });
};

/** Mobile: `.betslip` is the scroll host (overflow-y:auto); `.betslip-content` is visible overflow. */
const scrollBetslipRootsToTop = () => {
  const root = betslipContainer.value;
  if (!root) return;
  root.scrollTop = 0;
  const outerPanel = root.closest('.mobile-betslip-content') as HTMLElement | null;
  if (outerPanel) outerPanel.scrollTop = 0;
  const innerContent = root.querySelector('.betslip-content') as HTMLElement | null;
  if (innerContent) innerContent.scrollTop = 0;
};

/** Full-screen mobile panel: show header and top of slip after add. */
const scrollToTop = () => {
  const run = () => scrollBetslipRootsToTop();
  nextTick(() => {
    run();
    requestAnimationFrame(() => {
      run();
      requestAnimationFrame(run);
    });
  });
};

const revealSuccessState = () => {
  nextTick(() => {
    scrollToTop();
    iframeCommunication.sendScrollToTop();
    iframeCommunication.sendImmediateHeightUpdate();

    [80, 220, 450].forEach((delay) => {
      window.setTimeout(() => {
        scrollToTop();
        iframeCommunication.sendScrollToTop();
        iframeCommunication.sendImmediateHeightUpdate();
      }, delay);
    });
  });
};


// Watch for changes in the betslip store to ensure stakes are set
watch(
  betslip,
  async (newBets: BetslipItem[]) => {
    if (isUpdatingFromProps.value) return; // Prevent recursion
    if (isClearingBetslip.value) return; // Prevent interference during clearing
    if (!newBets || !Array.isArray(newBets)) return; // Add null check
    
    // If betslip is empty (cleared), don't process it
    if (newBets.length === 0) return;

    await nextTick();
    // Use last stake if available, otherwise fall back to betDefault
    const lastStake = betslipStore.getLastStake || betDefault.value;
    const updatedBets = newBets.map((bet: BetslipItem) => {
      const { drawCount, numBets } = getBetLineMultipliers(bet);
      const rawStake = bet.stake || lastStake;
      const stake = normalizeStakeValue(rawStake, {
        ...getStakeNormalizeOptions(),
        odds: toNumber(bet.odds),
        drawCount,
        numBets,
      });
      return { ...bet, stake };
    });

    if (JSON.stringify(updatedBets) !== JSON.stringify(newBets)) {
      betslipStore.betslip = updatedBets;
      betslipStore.saveToStorage();
    }
  },
  { immediate: true, deep: true }
);

// Watch for changes in bets: mobile full-screen betslip → top; desktop → bottom
watch(
  () => bets.value.length,
  (newLength, oldLength) => {
    if (newLength > oldLength && newLength > 0) {
      if (isMobileViewport()) {
        scrollToTop();
      } else {
        scrollToBottom();
      }
    }
  }
);


const handleStakeKeydown = (event: KeyboardEvent) => {
  // Prevent comma input
  if (event.key === ',') {
    event.preventDefault();
  }
};

const handleStakeFocus = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  // Store the current betslip value as the starting point
  const currentBet = betslip.value?.[index];
  localStakeValues.value[index] = String(currentBet?.stake || betDefault);
};

const handleStakeChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  let value = target.value;

  // Remove any commas from the input
  value = value.replace(/,/g, '');

  // Store the cleaned input value locally
  localStakeValues.value[index] = value;

  // Allow empty input for user to type
  if (value === "") {
    return;
  }

  // Parse the value as float
  let stake = parseFloat(value);

  // If it's not a valid number, don't update betslip but keep local value
  if (isNaN(stake)) {
    return;
  }

  // Validate minimum stake immediately
  if (stake < betMin.value) {
    // Don't update betslip if below minimum, but keep local value for user to continue typing
    return;
  }

  // Update betslip immediately for calculations
  updateBetStake(index, stake, false);
  
  // Save the stake as the last used stake
  updateLastStake(stake);
};

const handleStakeBlur = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement;
  let value = target.value.trim();

  // Remove any commas from the input
  value = value.replace(/,/g, '');

  // Clear local value to show betslip value
  delete localStakeValues.value[index];

  // Handle empty input
  if (value === "") {
    updateBetStake(index, betMin.value, true);
    return;
  }

  // Parse the value as float
  let stake = parseFloat(value);

  // If it's not a valid number, set to minimum
  if (isNaN(stake)) {
    updateBetStake(index, betMin.value, true);
    return;
  }

  // Update the betslip with the final value
  updateBetStake(index, stake, true);
  
  // Save the stake as the last used stake
  updateLastStake(stake);
};

const hasSelectedNumbers = (numbers: number[][]) => {
  if (!Array.isArray(numbers)) return false;
  return numbers.some(
    (numberArray) => Array.isArray(numberArray) && numberArray.length > 0
  );
};


const updateBetStake = (
  displayIndex: number,
  value: string | number,
  isBlur = false
) => {
  if (!betslip.value) return;

  // Display index now matches actual betslip index
  const actualIndex = displayIndex;

  let stakeValue = Number(value);

  // Handle invalid values
  if (isNaN(stakeValue)) {
    return; // Don't update if invalid
  }

  // Handle empty or zero values
  if (stakeValue <= 0) {
    stakeValue = 0;
  }

  const bet = betslip.value[actualIndex];
  const { drawCount, numBets } = getBetLineMultipliers(bet);
  stakeValue = normalizeStakeValue(stakeValue, {
    ...getStakeNormalizeOptions(),
    odds: toNumber(bet.odds),
    drawCount,
    numBets,
  });

  const updatedBet = {
    ...bet,
    stake: stakeValue,
  };
  betslipStore.betslip[actualIndex] = updatedBet;
  betslipStore.saveToStorage();
  
  // Save the stake as the last used stake
  updateLastStake(stakeValue);
};

const formatMarketDescription = (
  description: string,
  specifier: string | null
) => {
  if (description && description.includes("{value}") && specifier) {
    return description.replace("{value}", specifier);
  }
  return description;
};

const formatBetLabel = (
  label: string,
  config: { specifier_value?: string }
) => {
  if (label && label.includes("{value}") && config?.specifier_value) {
    return label.replace("{value}", config.specifier_value);
  }
  return label;
};

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const buildBackendPayload = () => {
  const betsPayload = bets.value.map((bet) => {
    // Simplified: always single outcome bets
    return {
      game_id: bet.game_id,
      market_id: bet.market_id,
      market_group_id: Number(bet.market_group_id),
      draws: Array.isArray(bet.draws) ? bet.draws : [],
      numbers: bet.numbers,
      picks: bet.picks,
      stake: bet.stake,
      outcome_id: Number(bet.outcome_id),
      ...(bet.game_market_id ? { game_market_id: Number(bet.game_market_id) } : {}),
      ...(bet.specifier != null && bet.specifier !== '' ? { specifier: String(bet.specifier) } : {}),
    };
  });
  return {
    bets: betsPayload,
    total_bet_amount: totalStake.value,
    ...(currentBookingCode.value ? { booking_code: currentBookingCode.value } : {}),
  };
};

const router = useRouter();
const route = useRoute();
const lastBetReference = ref<string | null>(null);

const validateBetLimitsBeforeSubmit = (): string | null => {
  const maxPerLine = unref(betMax);
  const minPerLine = unref(betMin);
  const maxPayout = unref(payoutMax);
  const maxTotalStake = unref(betLimit);
  const applyPayoutMaxToBetslip = unref(payoutMaxPerBetslip);

  for (const bet of bets.value) {
    const stake = toNumber(bet.stake);
    const { drawCount, numBets } = getBetLineMultipliers(bet);
    const odds = toNumber(bet.odds);

    if (minPerLine > 0 && stake < minPerLine) {
      return `Bet amount is below the minimum limit.`;
    }
    if (maxPerLine > 0 && stake > maxPerLine) {
      return `Bet amount exceeds the maximum limit. Maximum allowed bet per selection is ${maxPerLine}.`;
    }
    if (!applyPayoutMaxToBetslip && maxPayout > 0 && odds > 0) {
      const potentialWin = calcPotentialWin(stake, odds, drawCount, numBets);
      if (potentialWin > maxPayout) {
        return `The expected winnings amount must be smaller than ${maxPayout}.`;
      }
    }
  }

  if (applyPayoutMaxToBetslip && maxPayout > 0) {
    const totalPotentialWin = sumPotentialWins(betPotentialInputs.value);
    if (totalPotentialWin > maxPayout) {
      return `The expected winnings amount must be smaller than ${maxPayout}.`;
    }
  }

  if (maxTotalStake > 0 && totalStake.value > maxTotalStake) {
    return `Total stake exceeds the maximum limit of ${maxTotalStake}.`;
  }

  return null;
};

const handleBetButtonClick = () => {
  if (!isAuthenticated.value) {
    console.log('Sending login request from handleBetButtonClick');
    iframeCommunication.sendLoginRequest('bet-placement-required');
    return;
  }
  
  // User is authenticated, proceed with placing bet
  placeBet();
};

const placeBet = async () => {
  if (isProcessingBet.value || isEmpty.value || exceedsBetslipPayoutMax.value) return;

  // Check for expired draws and show options if found
  if (!handleExpiredBets()) {
    return; // Don't proceed if there are expired bets
  }

  const limitError = validateBetLimitsBeforeSubmit();
  if (limitError) {
    showToast({
      title: t("common.error"),
      message: limitError,
      type: "error",
      duration: 4000,
    });
    return;
  }

  // Validate bet count against payload_max before submitting
  const gameStore = useGameStore();
  const maxBets = gameStore.getBetSettings?.payload_max || 2000;
  if (bets.value.length > maxBets) {
    showToast({
      title: t("toast.maxBetsExceeded"),
      message: t("toast.maxBetsExceededMsg", { count: bets.value.length, max: maxBets }),
      type: "error",
      duration: 4000,
    });
    return;
  }

  // Validate outcome_id is required for all bets
  const invalidBets = bets.value.filter(
    (bet) => !bet.outcome_id || bet.outcome_id === ""
  );
  if (invalidBets.length > 0) {
    // Reset success message if showing
    showSuccess.value = false;
    showToast({
      title: t("toast.invalidBetConfiguration"),
      message: t("toast.invalidBetConfigurationMsg"),
      type: "error",
      duration: 4000,
    });
    return;
  }

  isProcessingBet.value = true;

  try {
    const payload = buildBackendPayload();
    const result = await transactionsStore.createBet(payload);
    if (result.status === "success") {
      lastBetReference.value = result.bets_processed.reference;
      showSuccess.value = true;
      showToast({
        title: t("toast.betPlaced"),
        message: t("toast.betPlacedMsg"),
        type: "success",
        duration: 3000,
      });
      const betSummary = {
        reference: result.bets_processed.reference,
        betsPlaced: bets.value.length,
        totalStake: totalStake.value,
        potentialReturns: totalReturns.value,
        timestamp: new Date().toISOString(),
      };
      iframeCommunication.sendMessage("bet-placed", betSummary);
      emit("clearedAfterSubmission");
      currentBookingCode.value = null;
      clearBetslip(false);
      revealSuccessState();
      try {
        await transactionsStore.fetchTransactions();
      } catch (error) {
        console.error('Error refreshing wagers history:', error);
      }
      
      // Remove success message after 3 seconds
      setTimeout(() => {
        showSuccess.value = false;
      }, 3000);
      
      // Close modal after 5 seconds
      setTimeout(() => {
        emit("close");
      }, 5000);
    } else {
      throw new Error("Failed to place bet");
    }
  } catch (error: unknown) {
    // Reset success message if showing
    showSuccess.value = false;
    
    // Use the enhanced error message from the global interceptor
    const errorMessage =
      (error as { userMessage?: string })?.userMessage ||
      "Failed to place bet. Please try again.";

    // Set inline error message above BET NOW button
    inlineError.value = errorMessage;

    showToast({
      title: t("common.error"),
      message: errorMessage,
      type: "error",
      duration: 5000,
    });

    // Clear inline error after 5 seconds
    setTimeout(() => {
      inlineError.value = null;
    }, 5000);
  } finally {
    isProcessingBet.value = false;
  }
};

const viewLastBet = async () => {
  if (!lastBetReference.value) {
    return;
  }

  try {
    isLoadingLastBet.value = true;
    const reference = lastBetReference.value;
    await transactionsStore.fetchTransactionDetail(reference);
    isLastBetModalOpen.value = true;
  } catch (error) {
    showToast({
      title: t("common.error"),
      message: t("toast.failedToLoadLastBet"),
      type: "error",
      duration: 4000,
    });
  } finally {
    isLoadingLastBet.value = false;
  }
};

const viewWagers = () => {
  emit("close");
  nextTick(() => {
    router.push({ path: "/wagers", query: route.query });
  });
};

const handleBookBet = async () => {
  if (!isAuthenticated.value || isEmpty.value || isProcessingBookBet.value) return;
  if (!handleExpiredBets()) return;
  const invalidBets = bets.value.filter((b) => !b.outcome_id || b.outcome_id === "");
  if (invalidBets.length > 0) {
    showToast({ title: t("toast.invalidBet"), message: t("toast.missingOutcomeInfo"), type: "error", duration: 4000 });
    return;
  }
  isProcessingBookBet.value = true;
  try {
    const currentBets = [...bets.value];
    const payload = buildBackendPayload();
    const result = await transactionsStore.bookBet(payload);
    if (result?.status === "success") {
      bookBetSuccessData.value = {
        booking_code: result.booking_code || "",
        barcode: result.barcode,
        expires_at: result.expires_at,
        total_bet_amount: result.total_bet_amount,
        bets: currentBets,
      };
      emit("clearedAfterSubmission");
      clearBetslip(false);
      revealSuccessState();
      showToast({ title: t("toast.betBooked"), message: result.message || t("toast.betBookedMsg"), type: "success", duration: 3000 });
    } else {
      throw new Error(result?.message || "Failed to book bet");
    }
  } catch (err: unknown) {
    const msg = (err as { userMessage?: string })?.userMessage || (err as Error)?.message || t("toast.failedToBookBet");
    showToast({ title: t("common.error"), message: msg, type: "error", duration: 5000 });
  } finally {
    isProcessingBookBet.value = false;
  }
};

const loadBookedBet = async () => {
  const code = bookingCodeInput.value?.trim();
  if (!code || !isAuthenticated.value || isLoadingBooking.value) return;
  isLoadingBooking.value = true;
  bookingMessage.value = "";
  bookingErrorMessage.value = "";
  try {
    const result = await transactionsStore.loadBookedBet(code);
    if (result?.status === "success" && result?.bet_data?.bets?.length) {
      currentBookingCode.value = result.booking_code || null;
      storeClearBetslip();
      const betsToAdd = result.bet_data.bets as Array<{
        game_id: number;
        market_id: number;
        market_group_id?: number;
        game_name?: string;
        market_name?: string;
        draws?: Array<{ draw_date: string; cutoff: string; event_id: number }>;
        numbers?: number[][];
        stake?: number;
        outcome_id?: string | number;
        odds?: number | string;
        picks?: number;
      }>;
      for (const b of betsToAdd) {
        const item: BetslipItem = {
          market_id: b.market_id,
          market_group_id: b.market_group_id ?? 0,
          game_id: b.game_id,
          game_name: b.game_name,
          draws: Array.isArray(b.draws) ? b.draws : [],
          numbers: Array.isArray(b.numbers) ? b.numbers : [[], []],
          stake: Number(b.stake) || 0,
          outcome_id: String(b.outcome_id ?? ""),
          market_name: b.market_name,
          odds: typeof b.odds === "string" ? parseFloat(b.odds) : b.odds,
          picks: b.picks,
        };
        betslipStore.addBet(item);
      }
      bookingCodeInput.value = "";
      bookingMessage.value = result.draws_updated
        ? "Booked bet loaded. Draw date was updated to the next available. Review and place bet."
        : "Booked bet loaded. Review and place your bet.";
      setTimeout(() => { bookingMessage.value = ""; }, 5000);
    } else {
      bookingErrorMessage.value = result?.message || "No bet data returned.";
      setTimeout(() => { bookingErrorMessage.value = ""; }, 5000);
    }
  } catch (err: unknown) {
    const msg = (err as { userMessage?: string })?.userMessage || (err as Error)?.message || "Failed to load booked bet";
    bookingErrorMessage.value = msg;
    setTimeout(() => { bookingErrorMessage.value = ""; }, 5000);
  } finally {
    isLoadingBooking.value = false;
  }
};

const downloadBookedBarcode = () => {
  const d = bookBetSuccessData.value;
  if (!d) return;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  // Thermal receipt style dimensions
  const width = 400;
  const padding = 20;
  const lineHeight = 20;
  let currentY = 40;

  // Pre-calculate height
  let estimatedHeight = 250; // Header and Footer
  if (d.bets) {
    d.bets.forEach((bet) => {
      estimatedHeight += 80; // Basic bet info
      if (bet.numbers && hasSelectedNumbers(bet.numbers)) {
        estimatedHeight += 30; // Numbers row
      }
      if (Array.isArray(bet.draws)) {
        estimatedHeight += 20 * Math.ceil(bet.draws.length / 2); // Draws
      }
    });
  }
  if (d.barcode) estimatedHeight += 120;

  canvas.width = width;
  canvas.height = estimatedHeight;

  // Background
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, estimatedHeight);

  // Header
  ctx.fillStyle = "#000000";
  ctx.font = "bold 20px Arial";
  ctx.textAlign = "center";
  ctx.fillText(t("receipt.bookingReceipt"), width / 2, currentY);
  currentY += 30;

  ctx.font = "14px Arial";
  ctx.fillText(`${t("receipt.bookingCode")}: ${d.booking_code}`, width / 2, currentY);
  currentY += 25;

  ctx.font = "12px Arial";
  ctx.fillText(`${t("receipt.date")}: ${new Date().toLocaleString()}`, width / 2, currentY);
  currentY += 20;

  // Separator
  ctx.beginPath();
  ctx.moveTo(padding, currentY);
  ctx.lineTo(width - padding, currentY);
  ctx.stroke();
  currentY += 20;

  // Bets
  if (d.bets) {
    d.bets.forEach((bet, index) => {
      ctx.textAlign = "left";
      ctx.font = "bold 14px Arial";
      ctx.fillText(`${index + 1}. ${bet.game_name || t("receipt.unknownGame")}`, padding, currentY);
      currentY += lineHeight;

      ctx.font = "12px Arial";
      ctx.fillText(`${t("receipt.market")}: ${bet.market_name || ""}`, padding + 10, currentY);
      currentY += lineHeight;

      if (bet.numbers && hasSelectedNumbers(bet.numbers)) {
        const mainNumbers = (bet.numbers[0] || []).join(", ");
        const bonusNumbers = (bet.numbers[1] || []).join(", ");
        let numbersText = `${t("betslip.numbersChosen")}: ${mainNumbers}`;
        if (bonusNumbers) numbersText += ` + ${t("receipt.bonus")}: ${bonusNumbers}`;
        
        ctx.fillText(numbersText, padding + 10, currentY);
        currentY += lineHeight;
      }

      if (Array.isArray(bet.draws) && bet.draws.length > 0) {
        const drawDates = bet.draws.map(dw => formatDate(dw.draw_date)).join(", ");
        // Wrap text if too long
        const maxWidth = width - (padding * 2) - 20;
        let words = drawDates.split(' ');
        let line = `${t("draws.selectDraws")}: `;
        for(let n = 0; words[n]; n++) {
          let testLine = line + words[n] + ' ';
          let metrics = ctx.measureText(testLine);
          if (metrics.width > maxWidth && n > 0) {
            ctx.fillText(line, padding + 10, currentY);
            line = words[n] + ' ';
            currentY += lineHeight;
          } else {
            line = testLine;
          }
        }
        ctx.fillText(line, padding + 10, currentY);
        currentY += lineHeight;
      }

      ctx.textAlign = "right";
      ctx.fillText(`${t("receipt.stake")}: ${formatCurrency(bet.stake || 0, unref(displayCurrency))}`, width - padding, currentY);
      currentY += 10;

      // Bet separator
      ctx.setLineDash([5, 5]);
      ctx.beginPath();
      ctx.moveTo(padding + 10, currentY);
      ctx.lineTo(width - padding, currentY);
      ctx.stroke();
      ctx.setLineDash([]);
      currentY += 20;
    });
  }

  // Footer
  ctx.textAlign = "center";
  ctx.font = "bold 16px Arial";
  ctx.fillText(`${t("receipt.totalAmount")}: ${formatCurrency(d.total_bet_amount || 0, unref(displayCurrency))}`, width / 2, currentY);
  currentY += 25;

  if (d.expires_at) {
    ctx.font = "12px Arial";
    ctx.fillText(`${t("receipt.expires")}: ${formatDate(d.expires_at)}`, width / 2, currentY);
    currentY += 20;
  }

  // Barcode
  if (d.barcode) {
    const img = new Image();
    img.onload = () => {
      // Scale barcode to fit width
      const barcodeWidth = 300;
      const barcodeHeight = 80;
      ctx.drawImage(img, (width - barcodeWidth) / 2, currentY, barcodeWidth, barcodeHeight);
      
      // Final download
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `bet-booking-${d.booking_code}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    img.src = `data:image/png;base64,${d.barcode}`;
  } else {
    // No barcode, download immediately
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `bet-booking-${d.booking_code}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const removeDraw = (displayBetIndex: number, drawIndex: number) => {
  if (!betslip.value) return;
  
  const actualBetIndex = displayBetIndex;
  const bet = betslip.value[actualBetIndex];
  
  if (!bet || !Array.isArray(bet.draws) || bet.draws.length === 0) return;
  
  if (bet.draws.length === 1) {
    showToast({
      title: t("toast.cannotRemoveLastDraw"),
      message: t("toast.cannotRemoveLastDrawMsg"),
      type: "info",
      duration: 3000,
    });
    return;
  }
  
  const removedDraw = bet.draws[drawIndex];
  const updatedDraws = bet.draws.filter((_, idx) => idx !== drawIndex);
  
  const updatedBet = {
    ...bet,
    draws: updatedDraws,
    drawCount: updatedDraws.length,
  };
  
  betslipStore.betslip[actualBetIndex] = updatedBet;
  betslipStore.saveToStorage();
  
  emit("selectDraws", {
    betIndex: actualBetIndex,
    drawCount: updatedDraws.length,
    selectedDraws: updatedDraws,
    gameId: bet.game_id,
  });
};

const toggleDrawDropdown = (index: number) => {
  if (openDrawDropdownIndex.value === index) {
    openDrawDropdownIndex.value = null;
  } else {
    openDrawDropdownIndex.value = index;
  }
};

const isDrawSelected = (draw: { draw_date: string; cutoff: string; event_id: number }, bet: BetslipItem): boolean => {
  if (!Array.isArray(bet.draws) || bet.draws.length === 0) return false;
  
  return bet.draws.some((selectedDraw) => {
    if (selectedDraw.event_id && draw.event_id) {
      return selectedDraw.event_id === draw.event_id;
    }
    return selectedDraw.draw_date === draw.draw_date;
  });
};

const toggleDrawSelection = (
  betIndex: number,
  draw: { draw_date: string; cutoff: string; event_id: number },
  event: Event
) => {
  if (!betslip.value) return;
  
  const bet = betslip.value[betIndex];
  if (!bet) return;
  
  const isChecked = (event.target as HTMLInputElement).checked;
  const currentDraws = Array.isArray(bet.draws) ? [...bet.draws] : [];
  
  if (isChecked) {
    // Add draw if not already selected
    const isAlreadySelected = currentDraws.some((selectedDraw) => {
      if (selectedDraw.event_id && draw.event_id) {
        return selectedDraw.event_id === draw.event_id;
      }
      return selectedDraw.draw_date === draw.draw_date;
    });
    
    if (!isAlreadySelected) {
      currentDraws.push(draw);
    }
  } else {
    // Remove draw, but ensure at least one remains
    if (currentDraws.length === 1) {
      showToast({
        title: t("toast.cannotRemoveLastDraw"),
        message: t("toast.cannotRemoveLastDrawMsg"),
        type: "info",
        duration: 3000,
      });
      // Re-check the checkbox
      (event.target as HTMLInputElement).checked = true;
      return;
    }
    
    const updatedDraws = currentDraws.filter((selectedDraw) => {
      if (selectedDraw.event_id && draw.event_id) {
        return selectedDraw.event_id !== draw.event_id;
      }
      return selectedDraw.draw_date !== draw.draw_date;
    });
    
    currentDraws.length = 0;
    currentDraws.push(...updatedDraws);
  }
  
  const updatedBet = {
    ...bet,
    draws: currentDraws,
    drawCount: currentDraws.length,
  };
  
  betslipStore.betslip[betIndex] = updatedBet;
  betslipStore.saveToStorage();
  
  emit("selectDraws", {
    betIndex: betIndex,
    drawCount: currentDraws.length,
    selectedDraws: currentDraws,
    gameId: bet.game_id,
  });
};

const isDrawExpired = (draw: string | { draw_date: string; cutoff: string }) => {
  // Accepts both string and object with cutoff time
  let cutoffTime: Date;
  
  if (typeof draw === "string") {
    cutoffTime = new Date(draw);
  } else {
    // Use cutoff time if available, otherwise fall back to draw_date
    cutoffTime = new Date(draw?.cutoff || draw?.draw_date);
  }

  // Check if the date is valid
  if (isNaN(cutoffTime.getTime())) {
    return false; // Invalid date, don't consider expired
  }

  // Check if cutoff time has passed (no buffer needed, be strict)
  const now = new Date();
  return cutoffTime.getTime() <= now.getTime();
};

const validateDraws = () => {
  const expired: { [betIndex: number]: number[] } = {};
  bets.value.forEach((bet, betIndex) => {
    if (Array.isArray(bet.draws)) {
      bet.draws.forEach((draw, drawIndex) => {
        if (isDrawExpired(draw)) {
          if (!expired[betIndex]) expired[betIndex] = [];
          expired[betIndex].push(drawIndex);
        }
      });
    }
  });
  
  const hasExpired = Object.keys(expired).length > 0;
  return !hasExpired;
};

// Check for expired draws and collect them for user action
const checkForExpiredDraws = () => {
  const expired: Array<{ betIndex: number; drawIndex: number; draw: { draw_date: string; cutoff: string; event_id: number } }> = [];
  bets.value.forEach((bet, betIndex) => {
    if (Array.isArray(bet.draws)) {
      bet.draws.forEach((draw, drawIndex) => {
        if (isDrawExpired(draw)) {
          expired.push({ betIndex, drawIndex, draw });
        }
      });
    }
  });
  return expired;
};

// Handle expired bet options
const handleExpiredBets = () => {
  const expired = checkForExpiredDraws();
  
  if (expired.length > 0) {
    expiredBets.value = expired;
    showExpiredBetOptions.value = true;
    return false; // Prevent bet submission
  }
  return true; // Allow bet submission
};

// Remove expired bets from betslip
const removeExpiredBets = () => {
  // Sort by betIndex in descending order to avoid index shifting issues
  const sortedExpired = [...expiredBets.value].sort((a, b) => b.betIndex - a.betIndex);
  
  sortedExpired.forEach(({ betIndex, drawIndex }) => {
    const bet = bets.value[betIndex];
    if (bet && Array.isArray(bet.draws)) {
      // Remove the expired draw
      bet.draws.splice(drawIndex, 1);
      
      // If no draws left, remove the entire bet
      if (bet.draws.length === 0) {
        removeBetAtIndex(betIndex);
      }
    }
  });
  
  // Hide the expired bet options and clear highlighting
  showExpiredBetOptions.value = false;
  expiredBets.value = [];
};

// Move expired bets to next available draw
const moveToNextDraw = () => {
  let hasMovedAny = false;
  let failedMoves = 0;
  
  // Filter to only process single draw bets
  const singleDrawExpiredBets = expiredBets.value.filter(({ betIndex }) => {
    const bet = bets.value[betIndex];
    return bet && Array.isArray(bet.draws) && bet.draws.length === 1;
  });
  
  if (singleDrawExpiredBets.length === 0) {
    showToast({
      title: t("toast.cannotMoveMultiDraw"),
      message: t("toast.cannotMoveMultiDrawMsg"),
      type: "error",
      duration: 4000,
    });
    return;
  }
  
  // Group expired bets by game_id to handle each game's draws separately
  const expiredBetsByGame = singleDrawExpiredBets.reduce((acc, { betIndex, drawIndex, draw }) => {
    const bet = bets.value[betIndex];
    if (bet && bet.game_id) {
      if (!acc[bet.game_id]) {
        acc[bet.game_id] = [];
      }
      acc[bet.game_id].push({ betIndex, drawIndex, draw, bet });
    }
    return acc;
  }, {} as Record<string | number, Array<{ betIndex: number; drawIndex: number; draw: { draw_date: string; cutoff: string; event_id: number }; bet: BetslipItem }>>);
  
  // Process each game's expired bets separately
  Object.entries(expiredBetsByGame).forEach(([gameId, gameExpiredBets]) => {
    // Get the first bet for this game to access its allAvailableDraws
    const firstBet = gameExpiredBets[0].bet;
    const availableDraws = firstBet.allAvailableDraws || [];
    
    if (availableDraws.length === 0) {
      failedMoves += gameExpiredBets.length;
      return;
    }
    
    // Filter out expired draws and get the next available draw for this specific game
    const validDraws = availableDraws.filter(draw => !isDrawExpired(draw));
    
    if (validDraws.length === 0) {
      failedMoves += gameExpiredBets.length;
      return;
    }
    
    const nextDraw = validDraws[0];
    
    // Update all expired draws for this game
    gameExpiredBets.forEach(({ betIndex, drawIndex }) => {
      const bet = bets.value[betIndex];
      if (bet && Array.isArray(bet.draws)) {
        // Update the bet in the betslip store
        const updatedDraws = bet.draws.map((draw, idx) => 
          idx === drawIndex 
            ? {
                draw_date: nextDraw.draw_date,
                cutoff: nextDraw.cutoff,
                event_id: nextDraw.event_id,
              }
            : draw
        );
        
        betslipStore.betslip[betIndex] = {
          ...bet,
          draws: updatedDraws,
        };
        hasMovedAny = true;
      }
    });
  });
  
  // Save the updated betslip to storage
  if (hasMovedAny) {
    betslipStore.saveToStorage();
  }
  
  // Hide the expired bet options and clear highlighting
  showExpiredBetOptions.value = false;
  expiredBets.value = [];
  
  // Show appropriate message based on results
  if (hasMovedAny && failedMoves === 0) {
    showToast({
      title: t("toast.movedToNextDraw"),
      message: t("toast.movedToNextDrawMsg"),
      type: "success",
      duration: 3000,
    });
  } else if (hasMovedAny && failedMoves > 0) {
    showToast({
      title: t("toast.partiallyMoved"),
      message: t("toast.partiallyMovedMsg", { count: failedMoves }),
      type: "info",
      duration: 4000,
    });
  } else {
    showToast({
      title: t("toast.noNextDraw"),
      message: t("toast.noNextDrawMsg"),
      type: "error",
      duration: 3000,
    });
  }
};

// Check if a specific bet has expired draws
const hasExpiredDraws = (bet: { draws?: Array<{ draw_date: string; cutoff: string; event_id: number }> }) => {
  if (!Array.isArray(bet.draws)) return false;
  return bet.draws.some((draw: { draw_date: string; cutoff: string; event_id: number }) => isDrawExpired(draw));
};

// Check if any of the expired bets have available next draws
const hasAnyGameWithNextDraw = computed(() => {
  if (expiredBets.value.length === 0) return false;
  
  // Check if any expired bet has only 1 draw (single draw bets can be moved)
  const hasSingleDrawBets = expiredBets.value.some(({ betIndex }) => {
    const bet = bets.value[betIndex];
    return bet && Array.isArray(bet.draws) && bet.draws.length === 1;
  });
  
  if (!hasSingleDrawBets) return false; // Only single draw bets can be moved
  
  // Get unique game IDs from expired bets
  const gameIds = new Set();
  expiredBets.value.forEach(({ betIndex }) => {
    const bet = bets.value[betIndex];
    if (bet && bet.game_id) {
      gameIds.add(bet.game_id);
    }
  });
  
  // Check if any game has available draws
  return Array.from(gameIds).some(gameId => {
    const betForGame = bets.value.find(bet => bet.game_id === gameId);
    return betForGame && betForGame.allAvailableDraws && betForGame.allAvailableDraws.length > 0;
  });
});

// Automatically clean up expired draws
const cleanupExpiredDraws = () => {
  if (!betslip.value || betslip.value.length === 0) return;

  // Don't clean up if there are expired draws - let user see the error and choose new draws
  if (!validateDraws()) {
    return;
  }

  let hasChanges = false;
  const currentGameId = gameStore.getGameDetail?.id;
  const betsToRemove: number[] = [];

  betslip.value.forEach((bet, betIndex) => {
    if (bet.game_id === currentGameId && Array.isArray(bet.draws)) {
      const validDraws = bet.draws.filter((draw) => !isDrawExpired(draw));

      if (validDraws.length === 0) {
        // No valid draws left, mark bet for removal
        betsToRemove.push(betIndex);
        hasChanges = true;
      } else if (validDraws.length !== bet.draws.length) {
        // Some draws were expired, update the bet
        betslipStore.betslip[betIndex] = {
          ...bet,
          draws: validDraws,
          drawCount: validDraws.length,
        };
        betslipStore.saveToStorage();
        hasChanges = true;
      }
    }
  });

  // Remove bets with no valid draws (in reverse order to maintain indices)
  betsToRemove.reverse().forEach((betIndex) => {
    removeBet(betIndex);
  });

  if (hasChanges) {
    // Only emit drawsChanged if there are still bets in the betslip
    if (betslip.value.length > 0) {
      // Emit event to update DetailView with the cleaned draws
      const allDraws: Array<{
        draw_date: string;
        cutoff: string;
        event_id: number;
      }> = [];
      betslip.value
        .filter((bet) => bet.game_id === currentGameId)
        .forEach((bet) => {
          if (Array.isArray(bet.draws)) {
            allDraws.push(...bet.draws);
          }
        });
      emit("drawsChanged", allDraws);
    }
  }
};

// Start cleanup timer on mount
onMounted(() => {
  // Detect mobile device
  const checkMobile = () => {
    isMobile.value = window.innerWidth <= 768;
  };
  
  checkMobile();
  window.addEventListener('resize', checkMobile);

  // Run cleanup every 30 seconds to remove expired draws
  cleanupTimer.value = window.setInterval(() => {
    cleanupExpiredDraws();
  }, 30000);

  // Close dropdown when clicking outside
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.draw-dropdown-wrapper')) {
      openDrawDropdownIndex.value = null;
    }
  };
  
  clickOutsideHandler.value = handleClickOutside;
  document.addEventListener('click', handleClickOutside);
});

// Clean up timer on unmount
onUnmounted(() => {
  if (cleanupTimer.value) {
    clearInterval(cleanupTimer.value);
    cleanupTimer.value = null;
  }
  
  // Remove resize listener
  const checkMobile = () => {
    isMobile.value = window.innerWidth <= 768;
  };
  window.removeEventListener('resize', checkMobile);
  
  // Remove click outside handler
  if (clickOutsideHandler.value) {
    document.removeEventListener('click', clickOutsideHandler.value);
    clickOutsideHandler.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "betslip betslip-body-surface",
      ref_key: "betslipContainer",
      ref: betslipContainer
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('betslip.title')), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(bets.value.length), 1)
      ]),
      (_unref(isAuthenticated) && showBookABetModule.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bookingCodeInput).value = $event)),
                type: "text",
                class: "booking-code-input",
                placeholder: _ctx.$t('betslip.enterBookingCode'),
                onKeyup: _withKeys(loadBookedBet, ["enter"])
              }, null, 40, _hoisted_5), [
                [_vModelText, bookingCodeInput.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "booking-search-btn",
                disabled: !bookingCodeInput.value.trim() || isLoadingBooking.value,
                onClick: loadBookedBet
              }, _toDisplayString(isLoadingBooking.value ? _ctx.$t('betslip.loading') : _ctx.$t('betslip.load')), 9, _hoisted_6)
            ]),
            (bookingMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(bookingMessage.value), 1))
              : _createCommentVNode("", true),
            (bookingErrorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(bookingErrorMessage.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(toast))
        ? (_openBlock(), _createBlock(ToastComponent, {
            key: 1,
            title: _unref(toast).title,
            message: _unref(toast).message,
            type: _unref(toast).type,
            duration: _unref(toast).duration
          }, null, 8, ["title", "message", "type", "duration"]))
        : _createCommentVNode("", true),
      (bets.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (bookBetSuccessData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t('betslip.betBookedSuccess')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('betslip.bookingCode')) + ":", 1),
                      _cache[5] || (_cache[5] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(bookBetSuccessData.value.booking_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('betslip.totalAmount')) + ":", 1),
                      _cache[6] || (_cache[6] = _createTextVNode()),
                      _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(bookBetSuccessData.value.total_bet_amount || 0, unref(displayCurrency.value))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('betslip.expires')) + ":", 1),
                      _cache[7] || (_cache[7] = _createTextVNode()),
                      _createElementVNode("span", null, _toDisplayString(formatDate(bookBetSuccessData.value.expires_at || '')), 1)
                    ])
                  ]),
                  (bookBetSuccessData.value.barcode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("img", {
                          src: `data:image/png;base64,${bookBetSuccessData.value.barcode}`,
                          alt: _ctx.$t('receipt.bookingReceipt'),
                          class: "barcode-img"
                        }, null, 8, _hoisted_18),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('betslip.scanOrUseCode')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "download-barcode-btn",
                      onClick: downloadBookedBarcode
                    }, _toDisplayString(_ctx.$t('betslip.downloadReceipt')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "done-btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (bookBetSuccessData.value = null))
                    }, _toDisplayString(_ctx.$t('common.done')), 1)
                  ])
                ]))
              : (showSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "success-icon" }, "🎉", -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('betslip.betPlacedSuccess')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('betslip.goodLuck')), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('betslip.empty')), 1)
                  ])),
            (_unref(isAuthenticated) && !bookBetSuccessData.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (lastBetReference.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "view-bet-button",
                        disabled: isLoadingLastBet.value,
                        onClick: viewLastBet
                      }, _toDisplayString(isLoadingLastBet.value ? _ctx.$t('betslip.loadingLastBet') : _ctx.$t('betslip.viewLastBet')), 9, _hoisted_26))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "view-bet-button",
                    onClick: viewWagers
                  }, _toDisplayString(_ctx.$t('betslip.viewWagers')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bets.value, (bet, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["bet-item", { 'expired-bet': showExpiredBetOptions.value && hasExpiredDraws(bet) }])
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(bet.game_name), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(formatDate(bet.draws?.[0]?.draw_date)), 1),
                    _createElementVNode("button", {
                      class: "close-button",
                      onClick: ($event: any) => (removeBetAtIndex(index))
                    }, " × ", 8, _hoisted_32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(bet.market_name), 1),
                    (!bet.numbers || !hasSelectedNumbers(bet.numbers))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(formatMarketDescription(
                      bet.market_description || "",
                      bet.specifier || ""
                    )), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(formatBetLabel(bet.label || "", {
                      specifier_value: bet.specifier || undefined,
                    })), 1)
                  ]),
                  (bet.numbers && hasSelectedNumbers(bet.numbers))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('betslip.numbersChosen')) + ":", 1),
                        _createElementVNode("div", _hoisted_40, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.isArray(bet.numbers) &&
                    Array.isArray(bet.numbers[0])
                      ? bet.numbers[0]
                      : [], (number) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'main-' + number,
                              class: "number-circle"
                            }, _toDisplayString(number), 1))
                          }), 128)),
                          (
                      Array.isArray(bet.numbers) &&
                      Array.isArray(bet.numbers[1]) &&
                      bet.numbers[1].length
                    )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (
                        Array.isArray(bet.numbers[0]) && bet.numbers[0].length
                      )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "+"))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.numbers[1], (bonus) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: 'bonus-' + bonus,
                                    class: "number-circle bonus"
                                  }, _toDisplayString(bonus), 1))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('betslip.draw')) + ":", 1),
                        _createElementVNode("div", _hoisted_47, [
                          (Array.isArray(bet.draws) && bet.draws.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bet.draws, (draw, drawIdx) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: drawIdx,
                                    class: "draw-badge"
                                  }, _toDisplayString(formatDate(draw?.draw_date)), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t('draws.noDrawsSelected')), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('betslip.stake')) + ":", 1),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("span", _hoisted_53, _toDisplayString(unref(displayCurrency.value) || unref(_unref(currencySymbol))), 1),
                          _createElementVNode("input", {
                            type: "number",
                            class: "stake-input",
                            value: 
                          localStakeValues.value[index] || bet.stake || _unref(betDefault)
                        ,
                            min: _unref(betMin),
                            max: _unref(betMax),
                            step: _unref(allowDecimals) ? 0.01 : 1,
                            placeholder: `${_unref(betMin)}`,
                            onInput: (event) => handleStakeChange(event, index),
                            onBlur: (event) => handleStakeBlur(event, index),
                            onFocus: (event) => handleStakeFocus(event, index),
                            onKeydown: _cache[2] || (_cache[2] = (event) => handleStakeKeydown(event))
                          }, null, 40, _hoisted_54)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.betType')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(bet.betType), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('transactionDetails.odds')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatOdds)(bet.odds)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.toWin')) + ":", 1),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(formatCurrency)(
                      getCappedWinForBet(bet),
                      unref(displayCurrency.value) || unref(_unref(currencySymbol))
                    )), 1)
                  ])
                ])
              ], 2))
            }), 128)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  class: "clear-button",
                  onClick: _cache[3] || (_cache[3] = () => clearBetslip())
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.clearAll')) + " ", 1),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "trash-icon" }, "🗑️", -1))
                ]),
                (showBookABetModule.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "book-bet-button",
                      disabled: isProcessingBookBet.value || exceedsBetslipPayoutMax.value,
                      onClick: handleBookBet
                    }, _toDisplayString(isProcessingBookBet.value ? _ctx.$t('common.loading') : _ctx.$t('results.bookABet')), 9, _hoisted_61))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.totalBetAmount')) + ":", 1),
                _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(formatCurrency)(totalStake.value, unref(displayCurrency.value))), 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('betslip.totalPotentialReturns')) + ":", 1),
                _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(formatCurrency)(totalReturns.value, unref(displayCurrency.value))), 1)
              ]),
              (showExpiredBetOptions.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "warning-icon" }, "⚠️", -1)),
                      _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('betslip.expiredBets')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("button", {
                        class: "remove-expired-btn",
                        onClick: removeExpiredBets
                      }, _toDisplayString(_ctx.$t('betslip.remove')), 1),
                      (hasAnyGameWithNextDraw.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "move-to-next-btn",
                            onClick: moveToNextDraw
                          }, _toDisplayString(_ctx.$t('betslip.moveToNext')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (inlineError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "error-icon" }, "❌", -1)),
                    _createElementVNode("span", _hoisted_71, _toDisplayString(inlineError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: _normalizeClass(["place-bet", {
                processing: isProcessingBet.value,
                unauthenticated: !_unref(isAuthenticated),
                'payout-max-exceeded': exceedsBetslipPayoutMax.value && _unref(isAuthenticated),
              }]),
                onClick: handleBetButtonClick,
                disabled: _unref(isAuthenticated) ? (isProcessingBet.value || isEmpty.value || showExpiredBetOptions.value || exceedsBetslipPayoutMax.value) : false
              }, [
                (exceedsBetslipPayoutMax.value && _unref(isAuthenticated))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                      _cache[12] || (_cache[12] = _createElementVNode("svg", {
                        viewBox: "0 0 20 20",
                        fill: "none",
                        class: "payout-max-warning-icon",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("circle", {
                          cx: "10",
                          cy: "10",
                          r: "7",
                          stroke: "currentColor",
                          "stroke-width": "1.8"
                        }),
                        _createElementVNode("path", {
                          d: "M10 8V12",
                          stroke: "currentColor",
                          "stroke-width": "1.8",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("circle", {
                          cx: "10",
                          cy: "5.8",
                          r: "1",
                          fill: "currentColor"
                        })
                      ], -1)),
                      _createElementVNode("span", null, _toDisplayString(betNowPayoutMaxMessage.value), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(!_unref(isAuthenticated) ? _ctx.$t('common.pleaseLogin') : (isProcessingBet.value ? _ctx.$t('common.pleaseWait') : _ctx.$t('common.betNow'))), 1)
                    ], 64))
              ], 10, _hoisted_72),
              _createElementVNode("button", {
                class: "close-betslip-button",
                onClick: closeBetslip
              }, _toDisplayString(_ctx.$t('common.close')), 1)
            ])
          ]))
    ], 512),
    _createVNode(BaseModal, {
      "is-open": isLastBetModalOpen.value,
      title: _ctx.$t('betslip.lastBetDetails'),
      "full-screen": "",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isLastBetModalOpen.value = false))
    }, {
      default: _withCtx(() => [
        (_unref(transactionsStore).currentTransaction)
          ? (_openBlock(), _createBlock(TransactionDetails, {
              key: 0,
              transaction: _unref(transactionsStore).currentTransaction
            }, null, 8, ["transaction"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open", "title"])
  ]))
}
}

})